export default __webpack_public_path__ + "static/media/aq.34fd7fc6.svg";